import React from 'react'
import { Parallax } from 'react-parallax'
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { Grid, Row, Col } from 'react-bootstrap'
import { graphql, Link } from 'gatsby'
import { FaCheck } from 'react-icons/fa';

const renderResidentialSection = (section) =>
    <Grid>
      <Row className="heading">
        <Col md={12}>
          <h2>{section.title}</h2>
        </Col>
      </Row>
      {section.notes !== null && (
        <Row>
          <Col md={12}>
            <br />
            <p className="no-h" style={{color:"#000"}}>{section.notes}</p>
          </Col>
        </Row>
      )}
      {section.residentialServices.map((service, i) => {
        if(service.featureList && service.featureList.length > 0){
          const firstColLength = Math.ceil(service.featureList.length/2)
          const firstColFeatures = service.featureList.slice(0,firstColLength)
          const secondColFeatures = service.featureList.slice(firstColLength)
          return (
            <div key={i}>
              <Row className="heading">
                <Col md={12}>
                <p style={{color:"#000"}}>{service.title}</p>
                </Col>
              </Row>
              {service.notes !== null &&
                (<Row>
                  <Col md={12}>
                    <p className="custom-text-color-1">{service.notes.notes}</p>
                  </Col>
                </Row>)
              }
              <Row>
                <Col md={6}>
                  <ul className="list list-icons custom-text-color-1">
                  {
                    firstColFeatures.map((feature, j) =>
                      <li key={j}><FaCheck className="fa" key={j}/> {feature} </li>
                    )
                  }
                  </ul>
                </Col>
                <Col md={6}>
                  <ul className="list list-icons custom-text-color-1">
                  {
                    secondColFeatures.map((feature, j) =>
                      <li key={j + firstColLength}><FaCheck className="fa" key={j}/> {feature} </li>
                    )
                  }
                  </ul>
                </Col>
              </Row>
              <br />
            </div>
          )
        } else {
          return <div></div>
        }
      })}
      </Grid>

const ResidentialPage = ({data}) => {
  const sortedSections = data.allContentfulResidentialSection.edges.sort((a,b) => (a.node.order - b.node.order))
  return (
      <Layout>
        <SEO title="Residential Property Management | Korecki Real Estate Services" description="Residential Property Management with Korecki Real Estate Services provides you with many benefis including but not limited to: Free market rent evaluation, Provide 24/7 emergency response to tenants and landlords, Prepare monthly financial statements" keywords="korecki,Real Estate,Strata Management services, Rent, Properties, Property Management, Client Property Account System, CPAS, Property Information"/>
        <div>
        <Parallax bgImage={require('../../images/seawall_v2.jpg')} bgImageAlt="Residential" strength={200}>
          <Grid>
            <Row>
              <Col md={12}>
                <h1>Residential</h1>
              </Col>
            </Row>
          </Grid>
        </Parallax>
        <br />
        {sortedSections.map((section) =>
          <section className="section background" key={section.node.order}>
            {renderResidentialSection(section.node)}
          </section>
        )}
        <Grid>
        <section className="last-section background ">
        <div class="row center">
          <Row style={{paddingTop: 20}}>
            <Col md={12}>
              <Link to="/residential/request" className="btn btn-outline btn-primary-1 text-uppercase">
                Residential Proposal Request
              </Link>
            </Col>
          </Row>
        </div>
        </section>
      </Grid>
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
      allContentfulResidentialSection {
        edges {
          node {
            order
            title
            notes
            residentialServices {
              title
              notes {
                notes
              }
              featureList
            }
          }
        }
     }
  }
  `
export default ResidentialPage
